import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Paper, Typography } from "@mui/material";
import TitlePayment, { PreTitlePayment } from "./TitlePayment";
import { numberWithCommas } from "@/utils/numbers";
import { BankCard } from "./BankCard";

export default function CardPaymentBox({
    charge,
    preTitle,
    onClose = () => {},
    onOpenUploader = () => {},
    displayButton,
}) {
    return (
        <>
            <Paper variant="outlined">
                <Grid
                    container
                    rowSpacing={1}
                    sx={{ padding: { xs: "15px", md: "20px" } }}
                >
                    <Grid item xs={12}>
                        {preTitle && (
                            <PreTitlePayment>{preTitle}</PreTitlePayment>
                        )}
                        <Grid display="flex" alignItems="center">
                            <TitlePayment>پرداخت کارت به کارت</TitlePayment>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "start",
                                }}
                            >
                                <NotRecommendedBadge />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Description charge={charge} />
                    </Grid>

                    <Grid sx={{ marginTop: "16px" }}>
                        <BankCard
                            ownerName="گروه تبلیغی ذوالفقار"
                            bankName="بانک ملی"
                            cardNumber="6037 9977 5001 7643"
                        />
                    </Grid>

                    <Grid sx={{ marginTop: "16px" }}>
                        <BankCard
                            ownerName="سید محمد حسینی نژاد"
                            bankName="بانک سامان"
                            cardNumber="6219 8619 9313 7412"
                        />
                    </Grid>

                    <Grid sx={{ marginTop: "16px" }}>
                        <BankCard
                            ownerName="سید محمد حسینی نژاد"
                            bankName="بانک مهر"
                            cardNumber="6063 7312 1649 2281"
                        />
                    </Grid>

                    <Grid sx={{ marginTop: "16px", marginBottom: "16px" }}>
                        <BankCard
                            ownerName="سید محمد حسینی نژاد"
                            bankName="بانک ملت"
                            cardNumber="6104 3376 7725 8236"
                        />
                    </Grid>

                    {displayButton && (
                        <Grid
                            container
                            xs={12}
                            display="flex"
                            justifyContent="end"
                        >
                            <Grid item xs={12} md={4}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{ whiteSpace: "nowrap" }}
                                    fullWidth
                                    onClick={() => {
                                        onClose();
                                        onOpenUploader();
                                    }}
                                    // disabled={loading}
                                >
                                    ارسال فیش واریزی
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Paper>
        </>
    );
}

function Description({ charge }) {
    if (charge) {
        return (
            <Typography sx={{ fontSize: "0.9rem" }}>
                برای رفع مسدودیت حساب، ابتدا مبلغ{" "}
                <Typography
                    component="span"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                        whiteSpace: "nowrap",
                    }}
                >
                    {numberWithCommas(charge)} تومان
                </Typography>{" "}
                را به شماره کارت زیر واریز کنید و{" "}
                <Typography variant="span" sx={{ fontWeight: "bold" }}>
                    سپس روی دکمه «ارسال فیش واریزی» بزنید.
                </Typography>{" "}
                <br />
                <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                    نکته:{" "}
                    <Typography
                        sx={{ fontSize: "0.9rem", fontWeight: "normal" }}
                        variant="span"
                    >
                        دقت کنید که پرداختی شما از مبلغ جریمه بیشتر یا کمتر
                        نباشد.
                    </Typography>
                </Typography>
            </Typography>
        );
    }

    return (
        <Typography sx={{ fontSize: "0.9rem" }}>
            مبلغ مورد نظر خود را به شماره کارت زیر واریز کنید و{" "}
            <Typography variant="span" sx={{ fontWeight: "bold" }}>
                سپس روی دکمه «ارسال فیش واریزی» بزنید.{" "}
            </Typography>
            <br />
            <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                نکته:{" "}
                <Typography
                    sx={{ fontSize: "0.9rem", fontWeight: "normal" }}
                    variant="span"
                >
                    دقت کنید که پرداختی شما از مبلغ مورد نظرتان بیشتر یا کمتر
                    نباشد.{" "}
                </Typography>
            </Typography>
        </Typography>
    );
}

const NotRecommendedBadge = () => {
    return (
        <Box
            sx={{
                backgroundColor: "#FFF9E6",
                borderRadius: "999px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
                marginLeft: "8px",
                height: "24px",
                position: "relative",
                top: "-2px",
            }}
        >
            <Typography
                sx={{
                    fontSize: "0.75rem",
                    padding: "0 8px",
                    margin: 0,
                    lineHeight: "1",
                    color: "#FFC107",
                    fontWeight: "bold",
                }}
            >
                توصیه نمی‌شود
            </Typography>
        </Box>
    );
};
